import $ from "jquery";
window.$ = window.jQuery = $;

// import 'bootstrap';
window.bootstrap = require("bootstrap/dist/js/bootstrap.bundle.js");

const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]'
);
const tooltipList = [...tooltipTriggerList].map(
    (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
);

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty("--vh", `${vh}px`);
document.documentElement.style.setProperty("--vhfixed", `${vh}px`);

// We listen to the resize event
window.addEventListener("resize", () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    if ($(window).width() > 768) {
        document.documentElement.style.setProperty("--vhfixed", `${vh}px`);
    }
});

var lazyLoadInstance = new LazyLoad();
import "./partials/header";
// import "./component-sets/aos";
import "./component-sets/video-embed";
import "./component-sets/scroll-magic";
import "./component-sets/table";
import "./component-sets/tabs";
import "./component-sets/heatmap";
import "./component-sets/share";
// import './component-sets/testimonial';
// import './component-sets/image-gallery';
